import { CustomerData } from '../../types/customer';
import { CardsSection } from './CardsSection';
import { CustomerProfileSection } from './CustomerProfileSection';
import { CustomerSubscriptionsSection } from './CustomerSubscriptionsSection';
import { CustomerSummaryFooter } from './CustomerSummaryFooter';

type CustomerSummaryTabProps = {
  customerData: CustomerData;
  setTabActive: (key: string) => void;
};

export const CustomerSummaryTab: React.FC<CustomerSummaryTabProps> = ({
  customerData,
  setTabActive,
}) => {
  return (
    <div>
      <CardsSection
        customerData={customerData}
        onClickClassOnMonth={() => setTabActive('1')}
        onClickPaymentsCard={() => setTabActive('3')}
      />
      <CustomerProfileSection customerData={customerData} />
      <CustomerSummaryFooter customerData={customerData} />
      <CustomerSubscriptionsSection customerData={customerData} />
    </div>
  );
};
